import { useMemo, useState } from "react";
import { SelectColorProps } from "./SelectColor";

type UseSelectColorArgs = {
  selectedColorValue: string;
} & Pick<SelectColorProps, "colors" | "path">;

export function useSelectColor({
  colors,
  path,
  selectedColorValue,
}: UseSelectColorArgs) {
  const [tmpSelectedColorValue, setTmpSelectedColorValue] =
    useState<string>("");
  const [prevPath, setPrevPath] = useState(path);

  if (path !== prevPath) {
    setPrevPath(path);
    setTmpSelectedColorValue(selectedColorValue);
  }

  const selectedColor = useMemo(() => {
    const _selectedColor = colors.filter(
      (color) => color.value === selectedColorValue,
    );
    return _selectedColor.length >= 0 ? _selectedColor[0] : undefined;
  }, [colors, selectedColorValue]);

  return {
    selectedColor,
    tmpSelectedColorValue,
  };
}
